/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path d="M10.7,15.3c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0L6,12.8l-4.3,2.5c-0.2,0.1-0.5,0.1-0.7,0 c-0.2-0.1-0.3-0.3-0.3-0.6V4c0-0.2,0.1-0.5,0.3-0.6l4.7-2.7c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0l0,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0,0l4.3,2.5l3.7-2.4c0.2-0.1,0.5-0.1,0.7,0s0.4,0.3,0.4,0.6V12 c0,0.2-0.1,0.4-0.3,0.6l-4,2.7c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1C10.8,15.3,10.7,15.3,10.7,15.3C10.7,15.3,10.7,15.3,10.7,15.3z M6.7,11.6l3.3,1.9V4.4L6.7,2.5V11.6z M2,4.4v9.1l3.3-1.9V2.5L2,4.4z M11.3,4.4v9.1l2.7-1.8V2.6L11.3,4.4z"/>'
  }
})